// Shared by OrderingTableFilters and OrderingDiameterFilter so every filter slot (dropdown, range, diameter)
// lines up to the same width and label style in the shared-header-row layout.
export const filterItemSx = { minWidth: 240, maxWidth: 300, flex: '0 1 280px' };
export const filterLabelSx = { mb: 0.75, fontWeight: 600 };
